// ─────────────────────────────────────────────────────────────────────────────
// Badge.jsx — MIAVIT style v2
// Sharp corners, DM Sans, used for categories, tags, sector labels
//
// Variants:
//   'green'   → light green bg, dark green text
//   'white'   → semi-transparent white, white text (on dark/image bg)
//   'dark'    → dark overlay bg, white text (category strip on images)
//   'amber'   → light amber bg, dark amber text
//   'outline' → transparent, green border
//
// Usage:
//   <Badge>Feed Additives</Badge>
//   <Badge variant="white">Poultry</Badge>
//   <Badge variant="dark">Industry News</Badge>
//   <Badge variant="amber">Performance</Badge>
//   <Badge variant="outline">Germany</Badge>
// ─────────────────────────────────────────────────────────────────────────────

export default function Badge({
  children,
  variant = 'green',   // 'green' | 'white' | 'dark' | 'amber' | 'outline'
  size    = 'sm',      // 'sm' | 'md'
  style: extraStyle = {},
}) {
  const configs = {
    green: {
      background: 'rgba(0,121,53,0.10)',
      color:      '#065e32',
      border:     'none',
    },
    white: {
      background: 'rgba(255,255,255,0.20)',
      color:      '#ffffff',
      border:     '1px solid rgba(255,255,255,0.35)',
    },
    dark: {
      background: 'rgba(0,0,0,0.55)',
      color:      '#ffffff',
      border:     'none',
    },
    amber: {
      background: 'rgba(237,151,22,0.12)',
      color:      '#a85610',
      border:     'none',
    },
    outline: {
      background: 'transparent',
      color:      '#007935',
      border:     '1px solid rgba(0,121,53,0.40)',
    },
  }

  const sizes = {
    sm: { fontSize: '11px', padding: '3px 8px'  },
    md: { fontSize: '12px', padding: '5px 12px' },
  }

  const c = configs[variant] || configs.green
  const s = sizes[size]      || sizes.sm

  return (
    <span style={{
      display:       'inline-flex',
      alignItems:    'center',
      fontFamily:    "'DM Sans', sans-serif",
      fontWeight:    600,
      letterSpacing: '0.07em',
      textTransform: 'uppercase',
      whiteSpace:    'nowrap',
      lineHeight:    1,
      background:    c.background,
      color:         c.color,
      border:        c.border || 'none',
      borderRadius:  0,   // MIAVIT: sharp corners
      ...s,
      ...extraStyle,
    }}>
      {children}
    </span>
  )
}